import React, { useEffect, useState } from 'react';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { setIsTableLoading, setPage, setRowsPerPage, setSearchValue, setItems, setTotalItems } from 'src/redux/slices/StudentLedgerSlice';
import { useParams } from 'react-router-dom';
import { useGetAllLedgerQuery, useGetLedgerBalanceQuery } from 'src/services/OfflineOrderService';
import ListDateTime from 'src/components/UI/atoms/ListDateTime/ListDateTime';
import { Tooltip } from '@mui/material';
import StudentLedgerListing from './StudentLedgerListing';

type Props = {};

const StudentLedgerListingWrapper = (props: Props) => {
    const dispatch = useDispatch();
    const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
        useSelector((state: RootState) => state.studentLedger);

    const [studentLedgerBalance, setStudentLedgerBalance] = useState()

    const { studentId } = useParams()
    const { data, isLoading, isFetching } = useGetAllLedgerQuery({
        limit: rowsPerPage,
        searchValue: searchValue,
        params: [
            "name",
            "mobile"
        ],
        page: page,
        filterBy: [
            {
                fieldName: "userId",
                value: studentId

            }
        ],
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: true,
    });

    // Setting Module Data
    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setIsTableLoading(false));
            dispatch(setTotalItems(data?.totalItem || 0));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isLoading, isFetching]);


    const { isLoading: studentLedgerIsLoading, isFetching: studentLedgerIsFetching, data: studentLedgerData } =
        useGetLedgerBalanceQuery(studentId || "");

    useEffect(() => {
        if (!studentLedgerIsLoading && !studentLedgerIsFetching) {
            setStudentLedgerBalance(studentLedgerData?.data);
        }
    }, [studentLedgerIsLoading, studentLedgerIsFetching, studentLedgerData]);



    const columns: columnTypes[] = [
        {
            field: "createdAt",
            headerName: "Date - Time",

            extraClasses: "min-w-[150px] py-1 min-w-[150px]",
            flex: "flex-[1_1_0%]",
            renderCell: (row: any) => <ListDateTime value={row.createdAt} />,
        },
        {
            field: "name",
            headerName: "Student Name",
            extraClasses: "justify-center",
            flex: "flex-[1_1_0%]",
            renderCell: (row: any) => (
                <div className="capitalize text-[13px]">{row?.name || "-"} </div>
            ),
        },
        {
            field: "adjustOrAdvance",
            headerName: "Type",
            extraClasses: "justify-center",
            flex: "flex-[1_1_0%]",
            renderCell: (row: any) => (
                <div className="capitalize text-[13px]">{row?.adjustOrAdvance || "-"} </div>
            ),
        },
        {
            field: "amount",
            headerName: "Amount",
            extraClasses: "justify-center",
            flex: "flex-[1_1_0%]",
            renderCell: (row: any) => (
                <div className="capitalize text-[13px]">Rs. {row?.amount || 0} </div>
            ),
        },
        {
            field: "remark",
            headerName: "Remark",
            flex: "flex-[2_2_0%]",
            renderCell: (row: any) => (
                <Tooltip title={row?.remark}>
                    <div className="capitalize text-[13px]"> {row?.remark} </div>
                </Tooltip>
            ),

        },

    ];


    return (
        <div>
            <StudentLedgerListing
                columns={columns}
                rows={items}
                studentLedgerBalance={studentLedgerBalance}
                paginationProps={{
                    isTableLoading,
                    totalItems,
                    page,
                    rowsPerPage,
                    searchValue,
                    setPage: (newPage) => dispatch(setPage(newPage)),
                    setRowsPerPage: (newRowsPerPage) =>
                        dispatch(setRowsPerPage(newRowsPerPage)),
                    setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                }}
            />
        </div>
    );
};

export default StudentLedgerListingWrapper;